<div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'Change company' | transloco }}</div>
        <button
            mat-icon-button
            (click)="cancel()"
            [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Form -->
    <form class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto" [formGroup]="composeForm">

        <mat-label class="mb-2.5">{{ 'Select the company you want to work with' | transloco }}</mat-label>

        <!-- Company -->
        <mat-form-field>
            <mat-select [formControlName]="'company'" [value]="user.companyId">
                <mat-option *ngFor="let userCompany of getUserCompanies()" [value]="userCompany.id">{{ userCompany.name || "N/A" }}</mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Actions -->
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">

            <div class="flex items-center mt-4 sm:mt-0">

                <!-- Send -->
                <button class="order-first sm:order-last" mat-flat-button [color]="'primary'"
                    (click)="changeCompany()">
                    {{  'Accept' | transloco }}
                </button>
            </div>

        </div>
    </form>

</div>
